import React from 'react'

import { FireStyledLinkNavItem } from '../../FireHeader.styles'

export function AccountNav({
  links,
  closeMobileNav,
  $isMobileOnly,
}: AccountNavProps) {
  return (
    <>
      {links.map(
        ({ text, href, forceAnchor, onClick, shouldCloseMobileNav }, index) => (
          <FireStyledLinkNavItem
            key={index}
            href={href}
            $isMobileOnly={$isMobileOnly}
            forceAnchor={forceAnchor}
            onClick={(e: React.SyntheticEvent) => {
              onClick?.(e)
              shouldCloseMobileNav && closeMobileNav()
            }}
          >
            {text}
          </FireStyledLinkNavItem>
        )
      )}
    </>
  )
}

interface AccountNavProps {
  links: {
    text: React.ReactNode
    href: string
    forceAnchor?: boolean
    onClick?: (e: React.SyntheticEvent) => void
    shouldCloseMobileNav?: boolean
  }[]
  closeMobileNav: () => void
  $isMobileOnly?: boolean
}
